require('es6-promise');
require('isomorphic-fetch');

import { createAction } from 'redux-actions';
import actionType from '../../consts/goods-detail-action-type';
import { DinnerType, INDUSTRY } from '../../helper/const';
import { getGoodsDetailAPI, takeawayDishListAPI, dishMenu4DinnerURL, getIndustryApi } from '../../config';
import router from '../../router';
import fetchHelper from '../../helper/fetch-helper';
import { getDishesLocalStorage } from '../../helper/dish-helper';
import { getUrlParam, getUrlParams, concatGoodsDetailWithRecommendList } from '../../helper/common-helper';

// 改为传参方式
// const id = getUrlParam('dishId');
const shopId = getUrlParam('shopId');
const type = getUrlParam('type') || DinnerType.TAKEOUT;

const initGoodsDetail = createAction(actionType.INIT_GOODS_DETAIL, detail => detail);
const setGoodsDetailWithRecommendList = createAction(actionType.SET_GOODS_DETAIL_WITH_RECOMMEND_LIST, detail => detail);
const setIndustryInfo = createAction(actionType.SET_INDUSTRY_INFO, detail => detail);

exports.fetchIndustryInfo = () => dispatch => {
  const api = `${getIndustryApi}?shopId=${shopId}`;
  return fetchHelper
    .get(api)
    .then((data = {}) => {
      const { industry = INDUSTRY.NORMAL } = data;
      dispatch(setIndustryInfo(industry));
      return industry;
    })
    .catch(ex => {
      throw ex;
    });
};

/**
 * 仅在本地开发环境使用
 */
const fetchGoodsDetailFromDishAll = (id) => dispatch =>
  fetchHelper.get(takeawayDishListAPI, { shopId }).then((res = {}) => {
    const { dishList = [] } = res;
    const goods = dishList.filter(item => item.id === id)[0];
    if (!goods) {
      return;
    }

    const { name } = goods;
    const sameRuleGoodsList = [goods].concat(dishList.filter(item => item.name === name && item.id !== id));
    dispatch(initGoodsDetail(sameRuleGoodsList));
  });

const fetchGoodsDetailFromAPI = (id) => dispatch =>
  fetchHelper
    .get(getGoodsDetailAPI, { shopId, type, dishId: id })
    .then((res = {}) => {
      const { dishBaseInfos: goodsList } = res || {};

      if (!goodsList) {
        throw new Error('该商品不存在');
      }

      dispatch(initGoodsDetail(goodsList));
    })
    .catch(() => {});

/**
 * 获取商品详情
 */
export const fetchGoodsDetail = process.env.NODE_ENV === 'production' ? fetchGoodsDetailFromAPI : fetchGoodsDetailFromDishAll;

/**
 * 初始已点菜列表
 */
export const initOrderedDishes = () => dispatch => {
  const { dishes } = getDishesLocalStorage({ shopId, type }) || { dishes: [] };
  const action = createAction(actionType.INIT_ORDERED_DISHES, distList => distList)(dishes);

  dispatch(action);
};

/**
 * 跳转到商品列表页
 */
exports.gotoGoodsListPage = () => () => {
  const params = getUrlParams() || {};
  const { dishId, ...others } = params;

  if (others.type === DinnerType.DINNERHALL) {
    fetchHelper.goto(dishMenu4DinnerURL, others);
    return;
  }

  fetchHelper.goto(router.goodsListUrl, others);
};

/* 连接菜品和猜你喜欢 */
exports.setGoodsDetailWithRecommendList = (recommendDishList, dishesDataDuplicate) => (dispatch, getState) => {
  const dishesDataDuplicateNew = concatGoodsDetailWithRecommendList(recommendDishList, dishesDataDuplicate, true);
  dispatch(setGoodsDetailWithRecommendList(dishesDataDuplicateNew));
};



// WEBPACK FOOTER //
// ./src/action/goods-detail/index.js